import React, { Component } from 'react'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import _ from 'lodash'
import { Row, Col, CardBody, Button, CardHeader } from 'reactstrap'
import { AvForm, AvField } from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'

const inspectionInputBase = { type_id: '', range: '', company_id: null, double_length: false }

class InspectionCategoryForm extends Component {

  constructor(props) {
    super(props)
    const ri_type = props.inspectionCategoryTypes.find(o => o.name === 'RI')
    this.state = {
      category_name: '',
      hold_time: '',
      inspection_input: [inspectionInputBase],
      ri_type_id: ri_type ? Number(ri_type.id) : false
    }
    this.handleOnSelectChange = this.handleOnSelectChange.bind(this)
    this.handleAddDynamicInput = this.handleAddDynamicInput.bind(this)
    this.handleDeleteInput = this.handleDeleteInput.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  static propTypes = {
    createOrUpdateCategoryMutation: PropTypes.func.isRequired,
    editData: PropTypes.object,
    projectId: PropTypes.number.isRequired,
    formToggleFunction: PropTypes.func.isRequired,
    afterSubmit: PropTypes.func.isRequired,
    inspectionCategoryTypes: PropTypes.array.isRequired,
    companiesData: PropTypes.array.isRequired
  }

  componentDidMount() {
    // withGaTracker(window.location.pathname + '/inspection_category_form') // GA TRACKER
  }

  componentWillMount() {
    this.fillFormDataFromProps(this.props)
  }

  componentWillReceiveProps(newProps) {
    this.fillFormDataFromProps(newProps)
  }

  fillFormDataFromProps(props) {
    if (props.editData) {
      const mappedInspections = [...props.editData.inspections]
        .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
        .map(inspection => {
          const mapped = {
            ...inspection
          }
          return mapped
        })
      this.setState({
        category_name: props.editData.name,
        hold_time: props.editData.hold_time,
        inspection_input: mappedInspections,
      })
    }
  }

  handleOnSelectChange(input_name, event, idx) {
    let newValue = this.state.inspection_input
    if (input_name === 'type_id' && Number(event.target.value) === this.state.ri_type_id) {
      newValue[idx] = { type_id: this.state.ri_type_id, range: 100 }
    } else if (input_name === 'double_length') {
      newValue[idx] = { ...newValue[idx], [input_name]: event.target.checked }
    } else {
      newValue[idx] = { ...newValue[idx], [input_name]: Number(event.target.value) }
    }
    this.setState({ inspection_input: newValue })
  }

  setSelectOptions(values) {
    if (values) {
      return values.map((o, idx) => {
        return (<option key={idx} value={o.id}>{o.name}</option>)
      })
    }
  }

  handleAddDynamicInput(e) {
    e.preventDefault()
    let newValue = this.state.inspection_input
    newValue.push(inspectionInputBase)
    this.setState({ inspection_input: newValue })
  }

  handleDeleteInput(idx) {
    let newValue = this.state.inspection_input
    this.setState({ inspection_input: newValue.filter((s, sidx) => idx !== sidx) })
  }

  moveUp = (idx) => {
    if (idx === 0) return
    const items = [...this.state.inspection_input]
    const temp = items[idx]
    items[idx] = items[idx - 1]
    items[idx - 1] = temp
    this.setState({ inspection_input: items })
  }

  moveDown = (idx) => {
    if (idx === this.state.inspection_input.length - 1) return
    const items = [...this.state.inspection_input]
    const temp = items[idx]
    items[idx] = items[idx + 1]
    items[idx + 1] = temp
    this.setState({ inspection_input: items })
  }

  onSubmit() {
    this.props.createOrUpdateCategoryMutation({
      variables: {
        id: this.props.editData && this.props.editData.id,
        name: this.state.category_name,
        hold_time: this.state.hold_time || null,
        project_id: this.props.projectId,
        inspections: this.state.inspection_input.map((o, index) => ({
          ..._.pick(o, 'type_id', 'range', 'company_id', 'double_length'),
          sort_order: index
        })),
      }
    })
      .then(() => {
        // withGaEvent({category: 'Inspection Category', action: 'save'}) // GA EVENT
        this.props.afterSubmit()
      })
  }

  render() {
    return (
      <div>
        <CardHeader>{this.props.editData ? 'Edit inspection category' : 'Add new inspection category'}</CardHeader>
        <CardBody>
          <AvForm onValidSubmit={this.onSubmit} className="FormClassLabel">
            <Row>
              <Col xs="12" sm="3">
                <AvField
                  name="name"
                  label="Category name"
                  required
                  validate={{ pattern: { value: '^[A-Za-z0-9]+$' } }}
                  value={this.state.category_name}
                  onChange={(e) => this.setState({ category_name: e.target.value })}
                />
              </Col>
              <Col xs="12" sm="3">
                <AvField
                  name="time"
                  label="Hold time (hours)"
                  type="number"
                  value={this.state.hold_time || ''}
                  onChange={(e) => this.setState({ hold_time: Number(e.target.value) })}
                />
              </Col>
            </Row>
            <br />

            {this.state.inspection_input.map((inspectionData, idx) => {
              let isRiType = inspectionData.type_id === this.state.ri_type_id
              return (
                <div key={idx} style={{ marginBottom: '10px', border: '1px solid #ddd', borderRadius: '4px', padding: '10px' }}>
                  <Row>
                    <Col xs="auto" style={{ paddingRight: '10px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', paddingTop: '28px' }}>
                        <Button size="sm" color="link" onClick={() => this.moveUp(idx)} disabled={idx === 0} style={{ padding: '2px 4px', lineHeight: '1' }}>
                          <i className="fa fa-arrow-up" style={{ fontSize: '12px' }} />
                        </Button>
                        <Button size="sm" color="link" onClick={() => this.moveDown(idx)} disabled={idx === this.state.inspection_input.length - 1} style={{ padding: '2px 4px', lineHeight: '1' }}>
                          <i className="fa fa-arrow-down" style={{ fontSize: '12px' }} />
                        </Button>
                      </div>
                    </Col>
                    <Col xs="1" style={{ paddingLeft: '0px' }}>
                      <AvField
                        label="Type"
                        type="select"
                        name={`type_id_${idx}`}
                        required
                        value={inspectionData.type_id || ''}
                        onChange={(event) => {
                          this.handleOnSelectChange('type_id', event, idx)
                        }}
                      >
                        <option></option>
                        {this.setSelectOptions(this.props.inspectionCategoryTypes)}
                      </AvField>
                    </Col>
                    <Col xs="1">
                      <AvField
                        label="Percent"
                        name={`range_${idx}`}
                        type="number"
                        min={1}
                        max={100}
                        required
                        value={inspectionData.range || ''}
                        disabled={isRiType}
                        onChange={(event) => {
                          this.handleOnSelectChange('range', event, idx)
                        }}
                      />
                    </Col>
                    <Col xs="2">
                      <AvField
                        label="Company"
                        type="select"
                        name={`company_id_${idx}`}
                        value={inspectionData.company_id || ''}
                        disabled={isRiType}
                        onChange={(event) => {
                          this.handleOnSelectChange('company_id', event, idx)
                        }}
                      >
                        <option></option>
                        {this.setSelectOptions(this.props.companiesData)}
                      </AvField>
                    </Col>
                    <Col xs="1">
                      <label style={{ fontSize: '14px' }}>Double length</label>
                      <div style={{ paddingTop: '5px' }}>
                        <input
                          type="checkbox"
                          checked={inspectionData.double_length === true}
                          onChange={(event) => {
                            this.handleOnSelectChange('double_length', event, idx)
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs="1">
                      <div style={{ paddingTop: '30px' }}>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => {
                            this.handleDeleteInput(idx)
                          }}
                        >
                          <i className="fa fa-minus" />
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              )
            })}
            <Row>
              <Col xs="12">
                <Button
                  color="primary"
                  onClick={this.handleAddDynamicInput}
                  style={{ marginLeft: '0px', marginTop: '20px' }}
                ><i className="fa fa-plus" /> New type
                </Button>
              </Col>
            </Row>

            <br />
            <Button color="danger" className="float-right " onClick={this.props.formToggleFunction}>
              <i className="fa fa-close" /> Close
            </Button>
            <Button type="submit" color="primary" className="float-right">
              <i className="fa fa-plus" /> Save
            </Button>
            <br /><br />
          </AvForm>
        </CardBody>
      </div>
    )
  }
}

const createOrUpdateInspectionCategoryMutation = gql`
  mutation createOrUpdateInspectionCategory($id: ID, $name: String!, $inspections: [InspectionInput], $project_id: ID!, $hold_time: Int) {
    createOrUpdateInspectionCategories(id: $id, name: $name, inspections: $inspections, project_id: $project_id, hold_time: $hold_time) {
      inspection_category {
        id
        name
        hold_time
        project {
          id
          name
        }
        inspections {
          type_id
          range
          company_id
          double_length
          sort_order
        }
      } 
      errors
    }
  }
`

const SelectWithData = graphql(
  createOrUpdateInspectionCategoryMutation, { name: 'createOrUpdateCategoryMutation' }
)(InspectionCategoryForm)

export default SelectWithData



// WEBPACK FOOTER //
// ./src/components/InspectionCategory/InspectionCategoryForm.js